// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body:has(> .hrone-dialog-mask:not(.hrone-dialog-scrollable)) {
  overflow: hidden !important;
}

hrone-dialog .hrone-dialog-mask:not(.hrone-dialog-mask--inline) {
  display: none !important;
}

.hrone-dialog-panel {
  display: flex;
  flex-direction: column;
  max-height: 90%;
  overflow: hidden;
  background-color: var(--theme-backgroundPrimary);
  border: 1px solid var(--theme-borderOpaque);
  border-radius: 16px;
  box-shadow: 0px 4px 16px 0px rgba(20, 30, 25, 0.0588235294), 0px 0px 0px 1px rgba(20, 30, 25, 0.0509803922);
  will-change: transform;
}

.hrone-dialog-panel--x-small {
  width: 400px;
}

.hrone-dialog-panel--small {
  width: 480px;
}

.hrone-dialog-panel--medium {
  width: 560px;
}

.hrone-dialog-panel--large {
  width: 720px;
}

.hrone-dialog-panel--x-large {
  width: 920px;
}

.hrone-dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-shrink: 0;
  margin: 20px 20px 0;
  padding-bottom: 0px;
  gap: 12px;
  position: relative;
}
.hrone-dialog-header .hrone-dialog-close {
  height: auto !important;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
}
.hrone-dialog-header .hrone-dialog-close i {
  font-size: 18px;
  color: var(--theme-black);
}

.hrone-dialog-title {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: var(--theme-contentPrimary) !important;
  margin: 0 !important;
  line-height: 20px !important;
}

.hrone-dialog-subtitle {
  font-size: 12px;
  font-weight: 400;
  color: var(--theme-contentTertiary);
  margin: 4px 0 0;
  line-height: 20px;
}

.hrone-dialog-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 2px 20px;
  position: relative;
  margin: 14px 0;
}
.hrone-dialog-content .btnclose {
  position: absolute;
  top: 8px;
  right: 16px;
}
.hrone-dialog-content .btnclose i {
  font-size: 18px;
  color: var(--theme-black);
}
.hrone-dialog-content .btnclose {
  z-index: 1;
}

.hrone-dialog-panel.no-padding .hrone-dialog-content {
  padding: 0;
}

.hrone-dialog-footer {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  gap: 12px;
  padding: 0px 20px 16px;
}

.hrone-dialog-mask {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  opacity: 0;
  transition: opacity 200ms ease-out;
}
.hrone-dialog-mask.hrone-dialog-mask--active {
  opacity: 1;
}
.hrone-dialog-mask.hrone-dialog-mask--closing {
  opacity: 0;
  transition: opacity 150ms ease-in;
}
.hrone-dialog-mask .hrone-dialog-panel {
  transform-origin: center center;
  opacity: 0;
  transform: scale(0.7);
  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1), opacity 200ms cubic-bezier(0, 0, 0.2, 1);
  background: var(--theme-backgroundPrimary);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--active {
  opacity: 1;
  transform: scale(1);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--closing {
  opacity: 0;
  transform: scale(0.7);
  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1), opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--position-right {
  transform: translateX(100%);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--position-right.hrone-dialog-panel--active {
  opacity: 1;
  transform: translateX(0);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--position-right.hrone-dialog-panel--closing {
  opacity: 0;
  transform: translateX(100%);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--position-left {
  transform: translateX(-100%);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--position-left.hrone-dialog-panel--active {
  opacity: 1;
  transform: translateX(0);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--position-left.hrone-dialog-panel--closing {
  opacity: 0;
  transform: translateX(-100%);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--position-top {
  transform: translateY(-100%);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--position-top.hrone-dialog-panel--active {
  opacity: 1;
  transform: translateY(0);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--position-top.hrone-dialog-panel--closing {
  opacity: 0;
  transform: translateY(-100%);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--position-bottom {
  transform: translateY(100%);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--position-bottom.hrone-dialog-panel--active {
  opacity: 1;
  transform: translateY(0);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--position-bottom.hrone-dialog-panel--closing {
  opacity: 0;
  transform: translateY(100%);
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--maximized {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  border-radius: 0 !important;
  transform: none !important;
}
.hrone-dialog-mask .hrone-dialog-panel.hrone-dialog-panel--draggable .hrone-dialog-header {
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
}

.hrone-dialog-mask--right {
  justify-content: flex-end;
}
.hrone-dialog-mask--right .hrone-dialog-panel {
  max-height: 100vh;
  margin-right: 16px;
}

.hrone-dialog-mask--left {
  justify-content: flex-start;
}
.hrone-dialog-mask--left .hrone-dialog-panel {
  max-height: 100vh;
  margin-left: 16px;
}

.hrone-dialog-mask--top {
  align-items: flex-start;
}
.hrone-dialog-mask--top .hrone-dialog-panel {
  margin-top: 16px;
}

.hrone-dialog-mask--bottom {
  align-items: flex-end;
}
.hrone-dialog-mask--bottom .hrone-dialog-panel {
  margin-bottom: 16px;
}

.hrone-dialog-mask--no-backdrop {
  background-color: transparent !important;
  pointer-events: none;
}
.hrone-dialog-mask--no-backdrop .hrone-dialog-panel {
  pointer-events: all;
}

@media (max-width: 767px) {
  .hrone-dialog-panel:not(.hrone-dialog-panel--maximized) {
    width: calc(100% - 16px) !important;
    max-width: calc(100% - 16px) !important;
    min-width: 0 !important;
    margin-left: 8px;
    margin-right: 8px;
  }
  .hrone-dialog-panel:not(.hrone-dialog-panel--maximized) .hrone-dialog-header {
    margin: 16px 16px 0;
  }
  .hrone-dialog-panel:not(.hrone-dialog-panel--maximized) .hrone-dialog-footer {
    padding: 0px 16px 16px;
  }
  .hrone-dialog-panel:not(.hrone-dialog-panel--maximized) .hrone-dialog-content {
    padding: 2px 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/hrone-ui-library/hrone-dialog/hrone-dialog.component.scss"],"names":[],"mappings":"AAUA;EACE,2BAAA;AATF;;AAcA;EACE,wBAAA;AAXF;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gDAAA;EACA,2CAAA;EACA,mBAAA;EACA,2GAAA;EAEA,sBAAA;AAhBF;;AAqBA;EAA+B,YAAA;AAjB/B;;AAkBA;EAA+B,YAAA;AAd/B;;AAeA;EAA+B,YAAA;AAX/B;;AAYA;EAA+B,YAAA;AAR/B;;AASA;EAA+B,YAAA;AAL/B;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAJF;AAME;EACE,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kCAAA;AAJJ;AAMI;EACE,eAAA;EACA,yBAAA;AAJN;;AASA;EACE,0BAAA;EACA,2BAAA;EACA,6CAAA;EACA,oBAAA;EACA,4BAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,eAAA;EACA,iBAAA;AANF;;AASA;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AANF;AAQE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;AANJ;AAOI;EACE,eAAA;EACA,yBAAA;AALN;AADE;EASE,UAAA;AALJ;;AAWA;EACE,UAAA;AARF;;AAWA;EACE,aAAA;EACA,yBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;AARF;;AAaA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,aAAA;EACA,UAAA;EACA,kCAAA;AAVF;AAYE;EACE,UAAA;AAVJ;AAaE;EACE,UAAA;EACA,iCAAA;AAXJ;AAgBE;EACE,+BAAA;EACA,UAAA;EACA,qBAAA;EACA,gGAAA;EACA,0CAAA;AAdJ;AAgBI;EACE,UAAA;EACA,mBAAA;AAdN;AAiBI;EACE,UAAA;EACA,qBAAA;EACA,oGAAA;AAfN;AAkBI;EACE,2BAAA;AAhBN;AAiBM;EAA+B,UAAA;EAAY,wBAAA;AAbjD;AAcM;EAAgC,UAAA;EAAY,2BAAA;AAVlD;AAaI;EACE,4BAAA;AAXN;AAYM;EAA+B,UAAA;EAAY,wBAAA;AARjD;AASM;EAAgC,UAAA;EAAY,4BAAA;AALlD;AAQI;EACE,4BAAA;AANN;AAOM;EAA+B,UAAA;EAAY,wBAAA;AAHjD;AAIM;EAAgC,UAAA;EAAY,4BAAA;AAAlD;AAGI;EACE,2BAAA;AADN;AAEM;EAA+B,UAAA;EAAY,wBAAA;AAEjD;AADM;EAAgC,UAAA;EAAY,2BAAA;AAKlD;AACI;EACE,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;AACN;AAEI;EACE,YAAA;EACA,yBAAA;UAAA,iBAAA;AAAN;;AAQA;EACE,yBAAA;AALF;AAOE;EACE,iBAAA;EACA,kBAAA;AALJ;;AAUA;EACE,2BAAA;AAPF;AASE;EACE,iBAAA;EACA,iBAAA;AAPJ;;AAYA;EACE,uBAAA;AATF;AAWE;EAEE,gBAAA;AAVJ;;AAcA;EACE,qBAAA;AAXF;AAaE;EACE,mBAAA;AAXJ;;AAiBA;EACE,wCAAA;EACA,oBAAA;AAdF;AAgBE;EACE,mBAAA;AAdJ;;AAoBA;EACE;IAEE,mCAAA;IACA,uCAAA;IACA,uBAAA;IACA,gBAAA;IACA,iBAAA;EAlBF;EAmBE;IACE,mBAAA;EAjBJ;EAmBE;IACI,sBAAA;EAjBN;EAmBE;IACE,iBAAA;EAjBJ;AACF","sourcesContent":["// hrone-dialog.component.scss\n// Self-contained styles for hrone-dialog — no PrimeNG classes or theme CSS.\n// ViewEncapsulation.None: every rule is scoped under an hrone-dialog-* class.\n// Consumer theming hooks live in _dialogbox.scss (via maskStyleClass / styleClass).\n//\n// Why motion uses `transition` + `-active` class toggle and `.hrone-dialog-owned`\n// scoping: see HRONE-DIALOG.md (Bug 1 / Bug 2).\n\n// ── Scroll lock — active while any blocking dialog mask is on body ──────────\n\nbody:has(> .hrone-dialog-mask:not(.hrone-dialog-scrollable)) {\n  overflow: hidden !important; // must beat page-level overflow rules while a dialog is open\n}\n\n// Flicker guard: keep the mask hidden for the one frame it still sits inside the host,\n// before ngAfterViewChecked moves it to body.\nhrone-dialog .hrone-dialog-mask:not(.hrone-dialog-mask--inline) {\n  display: none !important; // must beat consumer display rules on the mask\n}\n\n// ── Base panel / sections ───────────────────────────────────────────────────\n\n// Overflow model: the panel is a flex column capped at 90% of the viewport and never\n// scrolls itself. Header and footer stay pinned; only .hrone-dialog-content scrolls.\n.hrone-dialog-panel {\n  display: flex;\n  flex-direction: column;\n  max-height: 90%;\n  overflow: hidden;\n  background-color: var(--theme-backgroundPrimary);\n  border: 1px solid var(--theme-borderOpaque);\n  border-radius: 16px;\n  box-shadow: 0px 4px 16px 0px #141E190F,\n              0px 0px 0px 1px #141E190D;\n  will-change: transform;\n}\n\n// ── Size presets — width only. A width passed via [style] is inline, so it always wins. ──\n\n.hrone-dialog-panel--x-small { width: 400px; }\n.hrone-dialog-panel--small   { width: 480px; }\n.hrone-dialog-panel--medium  { width: 560px; }\n.hrone-dialog-panel--large   { width: 720px; }\n.hrone-dialog-panel--x-large { width: 920px; }\n\n.hrone-dialog-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-shrink: 0;\n  margin: 20px 20px 0; \n  padding-bottom: 0px;\n  gap: 12px;\n  position: relative;\n\n  .hrone-dialog-close{\n    height: auto !important;\n    padding: 0 !important;\n    border: 0 !important;\n    background: transparent !important;\n\n    i{\n      font-size: 18px;\n      color: var(--theme-black);\n    }\n  } \n}\n\n.hrone-dialog-title {\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  color: var(--theme-contentPrimary) !important;\n  margin: 0 !important;\n  line-height: 20px !important;\n}\n\n.hrone-dialog-subtitle{\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--theme-contentTertiary);\n  margin: 4px 0 0;\n  line-height: 20px;\n}\n\n.hrone-dialog-content {\n  flex: 1 1 auto;\n  min-height: 0; // lets the flex child shrink below its content height so overflow-y can kick in\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 2px 20px;\n  position: relative;\n  margin: 14px 0;\n\n  .btnclose{\n    position: absolute;\n    top: 8px;\n    right: 16px;\n    i{\n      font-size: 18px;\n      color: var(--theme-black);\n    }\n    // Keep it above positioned content rendered after it (e.g. task details .headersec), or that content swallows the click\n    z-index: 1;\n  }\n}\n\n// Edge-to-edge body: styleClass=\"no-padding\" removes the content padding.\n// overflow-x: hidden is already part of the base rule above.\n.hrone-dialog-panel.no-padding .hrone-dialog-content {\n  padding: 0;\n}\n\n.hrone-dialog-footer {\n  display: flex;\n  justify-content: flex-end;\n  flex-shrink: 0;\n  gap: 12px;\n  padding: 0px 20px 16px;\n}\n\n// ── Mask (full-viewport backdrop) ───────────────────────────────────────────\n\n.hrone-dialog-mask {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 1000; // overridden per-instance via [style.z-index]\n  opacity: 0;\n  transition: opacity 200ms ease-out;\n\n  &.hrone-dialog-mask--active {\n    opacity: 1;\n  }\n\n  &.hrone-dialog-mask--closing {\n    opacity: 0;\n    transition: opacity 150ms ease-in;\n  }\n\n  // ── Panel enter/leave motion ──────────────────────────────────────────────\n\n  .hrone-dialog-panel {\n    transform-origin: center center;\n    opacity: 0;\n    transform: scale(0.7);\n    transition: transform 200ms cubic-bezier(0.0, 0.0, 0.2, 1), opacity 200ms cubic-bezier(0.0, 0.0, 0.2, 1);\n    background: var(--theme-backgroundPrimary);\n\n    &.hrone-dialog-panel--active {\n      opacity: 1;\n      transform: scale(1);\n    }\n\n    &.hrone-dialog-panel--closing {\n      opacity: 0;\n      transform: scale(0.7);\n      transition: transform 150ms cubic-bezier(0.4, 0.0, 0.2, 1), opacity 150ms cubic-bezier(0.4, 0.0, 0.2, 1);\n    }\n\n    &.hrone-dialog-panel--position-right {\n      transform: translateX(100%);\n      &.hrone-dialog-panel--active { opacity: 1; transform: translateX(0); }\n      &.hrone-dialog-panel--closing { opacity: 0; transform: translateX(100%); }\n    }\n\n    &.hrone-dialog-panel--position-left {\n      transform: translateX(-100%);\n      &.hrone-dialog-panel--active { opacity: 1; transform: translateX(0); }\n      &.hrone-dialog-panel--closing { opacity: 0; transform: translateX(-100%); }\n    }\n\n    &.hrone-dialog-panel--position-top {\n      transform: translateY(-100%);\n      &.hrone-dialog-panel--active { opacity: 1; transform: translateY(0); }\n      &.hrone-dialog-panel--closing { opacity: 0; transform: translateY(-100%); }\n    }\n\n    &.hrone-dialog-panel--position-bottom {\n      transform: translateY(100%);\n      &.hrone-dialog-panel--active { opacity: 1; transform: translateY(0); }\n      &.hrone-dialog-panel--closing { opacity: 0; transform: translateY(100%); }\n    }\n\n    // ── State modifiers ─────────────────────────────────────────────────────\n    // !important: maximized must win over consumer [style] widths and any drag offset.\n\n    &.hrone-dialog-panel--maximized {\n      width: 100vw !important;\n      height: 100vh !important;\n      max-width: 100vw !important;\n      max-height: 100vh !important;\n      border-radius: 0 !important;\n      transform: none !important;\n    }\n\n    &.hrone-dialog-panel--draggable .hrone-dialog-header {\n      cursor: move;\n      user-select: none;\n    }\n  }\n\n}\n\n// ── Position variants (kept flat — low specificity so consumer rules can override) ──\n\n.hrone-dialog-mask--right {\n  justify-content: flex-end;\n\n  .hrone-dialog-panel {\n    max-height: 100vh;\n    margin-right: 16px;\n    // border-radius: 0;\n  }\n}\n\n.hrone-dialog-mask--left {\n  justify-content: flex-start;\n\n  .hrone-dialog-panel {\n    max-height: 100vh;\n    margin-left: 16px;\n    // border-radius: 0;\n  }\n}\n\n.hrone-dialog-mask--top {\n  align-items: flex-start;\n\n  .hrone-dialog-panel {\n    // border-radius: 0;\n    margin-top: 16px;\n  }\n}\n\n.hrone-dialog-mask--bottom {\n  align-items: flex-end;\n\n  .hrone-dialog-panel {\n    margin-bottom: 16px;\n    // border-radius: 0;\n  }\n}\n\n// No backdrop — mask is transparent, only the panel intercepts clicks\n.hrone-dialog-mask--no-backdrop {\n  background-color: transparent !important; // must beat maskStyleClass backdrop colours\n  pointer-events: none;\n\n  .hrone-dialog-panel {\n    pointer-events: all;\n  }\n}\n\n// ── Mobile (≤ 767px) — full width with a 16px gap on each side, for every size/position ──\n\n@media (max-width: 767px) {\n  .hrone-dialog-panel:not(.hrone-dialog-panel--maximized) {\n    // !important: must beat the size classes AND consumer widths passed inline via [style]\n    width: calc(100% - 16px) !important;\n    max-width: calc(100% - 16px) !important;\n    min-width: 0 !important;\n    margin-left: 8px;\n    margin-right: 8px;\n    .hrone-dialog-header{\n      margin: 16px 16px 0;\n    }\n    .hrone-dialog-footer{\n        padding: 0px 16px 16px;\n    }\n    .hrone-dialog-content{\n      padding: 2px 16px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
